import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { type SxProps } from '@mui/system'
import { useIsFetching } from '@tanstack/react-query'
import { type ReactNode } from 'react'
import { TRIP_DETAILS_QUERY_KEY } from 'screens/TripDetails/TripDetails.service'
import type { KNDataCardAction } from './TripDetails.types'

export interface PrimaryActionsProps {
  actions: KNDataCardAction[]
  sx?: SxProps
}

const PrimaryActions = ({
  actions,
  sx,
}: PrimaryActionsProps): ReactNode => {
  const isFetching = useIsFetching({ queryKey: [TRIP_DETAILS_QUERY_KEY] })

  if (actions.length === 0) {
    return null
  }

  return (
    <Stack
      data-guide="primary-actions"
      spacing={1}
      direction="row"
      justifyContent="flex-end"
      flexWrap="wrap"
      sx={{
        containerType: 'inline-size', // required for container queries
        ...sx,
      }}
    >
      {actions.map((action: KNDataCardAction) => (
        <Button
          key={action.label ?? action.color}
          variant={action.variant ?? 'contained'}
          color={action.color ?? 'primary'}
          startIcon={action.icon}
          onClick={(): void => action.handler()}
          disabled={action.disabled || isFetching > 0}
          sx={{
            ...(action.label ? {
              flexGrow: { '@': 1, '@400': 0 },
            } : {
              '.MuiButton-icon': {
                marginX: 0,
              },
            }),
          }}
        >
          {action.label}
        </Button>
      ))}
    </Stack>
  )
}

export default PrimaryActions
